import HandbookReader from "./HandbookReader";

export default function AdminHandbook() {
  return <HandbookReader kind="admin" />;
}
